import { render } from "./_icon-plus.vue?vue&type=template&id=37dabbb2"
import script from "./_icon-plus.vue?vue&type=script&lang=js"
export * from "./_icon-plus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__